/*eslint no-irregular-whitespace: ["error", { "skipTemplates": true }]*/
/*eslint-env es6*/

export default [
    {

        type: 'resource',
        name: '&nbsp;&nbsp;Resume&nbsp;&nbsp; Tips',
        title: ['Delfina’s Resume', '& Cover Letter Tips'],
        slug: 'resume-tips',
        media: 'Delfina_Mussa',
        job: 'Senior Consultant, Talent Attraction',
        text: [
            `Writing a resume and cover letter can be a challenge, especially when you’re trying to stand out from the crowd and showcase all the great qualities and skills that make you who you are. The campus team at Doane Grant Thornton would like to share some tips to create an exceptional resume and cover letter:`,

            {
                type: 'bullet-list',
                list: [
                    `Proofread your resume for spelling and grammar [have a friend do this as well – a fresh set of eyes is always best!]`,
                    `Tailor your resume for the specific role you are applying for – do not apply to too many roles with the same organization at one time if they are not aligned with your experience and interest`,
                    `Leave the technical details to the resume, use the cover letter to help the campus team get a sense of your personality, it’s ok to be conversational`,
                    `If you are applying to another city or country, mention in your cover letter why you are interested in relocating i.e.: (“I know I live in Ontario and the job is located in Prince Edward Island, but my family is originally from there, and I’ve been looking to move back!”)`
                ]
            },
        ]

    }, {

        type: 'resource',
        name: 'Interview Prep',
        title: ['Allen’s Interview', 'Prep Tips'],
        slug: 'interview-prep',
        media: 'Allen_Wang',
        job: 'Manager, Talent Attraction',
        text: [
            `After completing a digital interview, you may be selected to move forward with an in-person or live video interview with members of our local team. A few tips to help set you up for success include:`,
            
            {
                type: 'bullet-list',
                list: [
                    `Plan to arrive 10-15 minutes prior to the interview so you can catch your breath and settle in. [If you are participating in a live video interview – test your technology ahead of time!]`,
                    `Be Authentic! Your interviewer wants to see the real you!`,
                    `Your interview is a chance for you to get to know us as a firm, be prepared to ask insightful questions as they are a great way to see if we are the right choice for you!`,
                    `Leverage your network - if you know friends who have interviewed with Doane Grant Thornton in the past, or are one of our current colleagues, reach out! Ask for advice!`,
                    `Try embodying the organization’s values in your answers to demonstrate you’re a good cultural fit.`
                ]
            },
        ]

    }, {

        type: 'resource',
        name: 'After The Interview',
        title: ['Omar’s', 'Post-Interview', 'Tips'],
        slug: 'after-the-interview',
        media: 'Omar_Elshafey',
        job: 'Consultant, Talent Attraction',
        text: [
            `We know interviewing can be a stressful and nerve-wracking experience.  Once you have finished your in-person interview, our campus team would recommend that you: `,

            {
                type: 'bullet-list',
                list: [
                    `Thank the interviewers for their time before leaving the office [or signing off the video platform]`,
                    `Take a few moments for yourself and do something to calm your mind [ex. Go for a walk, do yoga, enjoy a nice sunset, etc..]`,        
                ]
            },
            `Our goal is to connect back with all candidates as soon as possible and you can anticipate hearing something in the coming days.`
        ]
    }, {

        type: 'events',
        name: 'Campus Events',
        title: 'Campus Events',
        slug: 'campus-events',
        media: 'Alex_Veltri',
        job: '',
        text: ``

    }, {

        type: 'resource',
        name: 'Digital Interviewing',
        title: ['Nicole’s Digital', 'Interviewing Tips'],
        slug: 'digital-interviewing',
        media: 'Nicole_Lucas',
        job: 'Senior Consultant, Talent Attraction [Campus]',
        text: [
            `Digital interviewing is a convenient, personal way to connect with our campus team. It allows you to record your answers to pre-set interview questions using your computer webcam or mobile device. You can share your story in a more personalized way, bring your resume to life and showcase your personality to the campus team.`,
            {
                link: '/static/campus/Digital-Interviewing-DoaneGT.pdf',
                text: `Click here to learn more about Digital Interviewing`
            },
            {
                link: 'https://grant-thornton.hirevue.com/signup/xZZBFFSvW8SD3mReZ9hXsV/',
                text: `Want to try a practice digital interview? Click here to try one before you do the real thing.`
            }
        ]

    }, {

        type: 'resource',
        name: 'Our Process',
        title: ['Khemwattie Shares Our Process'],
        slug: 'our-process',
        media: 'Khemwattie_Hurry',
        job: 'Senior Consultant, Talent Attraction',
        text: [
            {
                type: 'arrow-list',
                list: [
                    'Submission of Resume/Cover Letter/Transcripts',
                    'Digital Interview',
                    'In-Person or Live Video Interview',
                    'Offer Decision',
                ]
            },
            `We are committed to electronically confirming with all applicants when an application has been received and to electronically notify all applicants when positions they have applied to have been filled.`,
            {
                type: 'button-purple',
                text: 'View Current Openings',
                link: 'https://phh.tbe.taleo.net/phh01/ats/careers/v2/jobSearch?org=GRANTTHORNTON&cws=57'
            }
        ]

    },

    {

        type: 'resource',
        name: 'CPA Support',
        title: ['CPA Support'],
        slug: 'cpa-support',
        media: 'cpa-support',
        job: '',
        text: [
            `At Doane Grant Thornton, we’re committed to helping our clients, colleagues and communities thrive. What does this mean for you? It means that when you join our team, we’ll do everything we can to support you on your journey to obtain your CPA. And the support doesn’t stop there, it continues throughout your career at Doane Grant Thornton.`,
            
            {
                type: 'title',
                text: 'How we’ll support your CPA Journey',
            },

            {
                type: 'subtitle',
                text: `Personal CPA Mentor`,
            },
            `You’ll be paired with a specifically-trained CPA mentor for the entire 30 months of the program who will personally ensure you receive the necessary work experience to get your CPA. From the first day to the last, they’ll be completely committed to your success. `,

            {
                type: 'subtitle',
                text: `Knowledgeable CPA Champions`,
            },
            `Our team of CPA Champions provide local training to students across the country for each module within the PEP program. They will guide you through a series of workshops designed to prepare you with the technical skills and knowledge you need to be successful.`,

            {
                type: 'subtitle',
                text: `Dedicated CFE Coach`,
            },
            `You will be matched with a CFE Coach who will ensure you have the support you need to pass the CFE. Having recently written the exam, your coach will mark cases, share insights and provide helpful advice and guidance throughout your CFE study preparation.`,

            {
                type: 'subtitle',
                text: `Milestone Support`,
            },
            `Our customized training program ensures that you will receive support at every milestone along the way.`,
        ]

    },
]